<web-settings-breadcrumbs>
    <div class="breadcrumb-icon">
        <a (click)="onReset()">
            <img src="./assets/img/websites/lpc-back-icon.svg" class="first-breadcrumb-icon" alt="lpc-back-icon" />
        </a>
    </div>
    <div class="breadcrumb-text">
        <span>{{ "control_authorization_form_setting" | translate }}</span>
    </div>
</web-settings-breadcrumbs>

<div class="panel-options-body overflow-wrapper">
    <div class="form form-horizontal">
        <div class="form-row">
            <div class="form-group mb-20" [class.has-error]="isEmptyLabel()">
                <label class="col-xs-12">
                    {{ "control_button_text" | translate }}
                </label>
                <div class="col-xs-12">
                    <input class="form-control" [value]="label()" (input)="onLabelChange($event)" />
                    @if (isEmptyLabel()) {
                        <span class="help-block small">
                            {{ "control_errors_required" | translate }}
                        </span>
                    }
                </div>
            </div>

            <div class="form-group">
                <label class="col-xs-12">
                    {{ "control_button_style" | translate }}
                </label>
                <div class="col-xs-6">
                    <select class="form-control" (change)="onStyleTypeChange($event)">
                        <option
                            [value]="EButtonStyleType.primary"
                            [selected]="styleType() === EButtonStyleType.primary"
                        >
                            {{ "control_appearance_primary" | translate }}
                        </option>
                        <option
                            [value]="EButtonStyleType.secondary"
                            [selected]="styleType() === EButtonStyleType.secondary"
                        >
                            {{ "control_appearance_secondary" | translate }}
                        </option>
                        <option [value]="EButtonStyleType.custom" [selected]="styleType() === EButtonStyleType.custom">
                            {{ "control_appearance_custom" | translate }}
                        </option>
                    </select>
                </div>
                <div class="col-xs-6">
                    <div class="btn-group d-flex">
                        <sp-radio-group
                            [selected]="size()"
                            [type]="ERadioGroupType.size"
                            (changeSelectedEvent)="setSize($event)"
                        />
                    </div>
                </div>
            </div>

            @if (isCustomStyle()) {
                <web-custom-button
                    [isIndependentCorners]="isIndependentCorners()"
                    [radiusSettings]="$any(advancedRadius())"
                    [advancedBorderSettings]="$any(advancedBorderSettings())"
                    [isAdvancedRadius]="true"
                    [parentBase]="buttonBase()"
                    [parentHover]="buttonHover()"
                    (valueChangeEvent)="customButtonChangeHandler($event)"
                />
            }

            <div class="form-group" [class.mb-20]="!isShadow()" [class.mb-10]="isShadow()">
                <label class="col-xs-9 control-label">
                    {{ "control_shadow" | translate }}
                </label>
                <div class="col-xs-3 text-right">
                    <sp-switch [active]="isShadow()" (toggleActiveEvent)="setShadow($event)" />
                </div>
            </div>

            @if (isShadow()) {
                <sp-shadow-settings
                    [shadowSettings]="$any(shadowSettings())"
                    (valueChangeEvent)="setShadowSettings($event)"
                />
            }
        </div>
    </div>
</div>

<web-settings-footer [isSaveDisabled]="isEmptyLabel()" (saveEvent)="onSave()" (cancelEvent)="onReset()" />
